import { API_URL } from "config";
import Http from "util/https";
import { DestinationCheck } from "../types";

type Dest = {A: DestinationCheck, B: DestinationCheck, C: DestinationCheck}
type DestinationResponseApi = {
  shipping_list: {
    shipping_cd: number;
    shipping_name: string;
    shipping_address: string;
  }[];
}
const defaultDestination: DestinationCheck = {
  destinationCd: '',
  destinationName: '',
  destinationAddress: ''
};

/**
 * 発送先取得Api
 * @param clientCd 取得する得意先コード
 * @returns destinationApi
 */
export default async function getDestinationApi(clientCd?: string) {
  const http = Http.default.alterAuth({useToken: true});
  const url = clientCd ? `${API_URL}/order/shipping/list?client_cd=${clientCd}` : `${API_URL}/order/shipping/list`;
  const res = await http.get<DestinationResponseApi>(url);

  // const res: {data: DestinationResponseApi} = {
  //   data: {shipping_list:
  //     [{
  //       shipping_cd: '0001',
  //       shipping_name: '美女木1',
  //       shipping_address: '埼玉県戸田市美女木北２－１－１７'
  //     },{
  //       shipping_cd: '0002',
  //       shipping_name: '美女木2',
  //       shipping_address: '埼玉県戸田市美女木北２－１－１７'
  //     }]
  //   }
  // }

  const [A,B,C]: DestinationCheck[] = res.data.shipping_list.map(s => ({
    destinationCd: s.shipping_cd ? `${s.shipping_cd}` : '',
    destinationName: s.shipping_name ?? '',
    destinationAddress: s.shipping_address ?? '',
  }))

  const destination: Dest = {
    A: A ?? defaultDestination,
    B: B ?? defaultDestination,
    C: C ?? defaultDestination,
  };

  // await new Promise<void>((resolve) => {setTimeout(resolve, 1500)});
  console.log(res);
  console.log(destination);
  // return res.data;
  return {
    destination
  };
}